<template>
  <div class="skills-section">
    <h2 class="text-2xl font-bold mb-4" :style="{ color: themeColor, borderBottom: `2px solid ${themeColor}`, paddingBottom: '0.5rem' }">
      Skills
    </h2>
    <div class="flex flex-wrap gap-2">
      <span
        v-for="(skill, index) in section.data.items"
        :key="index"
        class="px-3 py-1 bg-gray-100 rounded-full text-gray-700"
      >
        {{ skill }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    section: {
      type: Object,
      required: true
    },
    themeColor: {
      type: String,
      default: '#17803d'
    }
  }
}
</script>

